/** Placement guides over the design while generating (Aziz 2026-10-26): what the profile grid shows
 *  (the centre 3:4 crop) and, on 9:16, where the reel's own top bar, buttons and caption sit.
 *  Screen only: it is a DOM layer over the canvas, so it never reaches the PNG, and it never takes clicks. */
export default function GridGuides({ w, h }: { w: number; h: number }) {
  const tall = w / h < 0.75;
  // the grid tile is 3:4: a tall design loses its top and bottom, a wide one its sides
  const crop = tall ? { x: 0, y: (h - w / 0.75) / 2, w, h: w / 0.75 } : { x: (w - h * 0.75) / 2, y: 0, w: h * 0.75, h };
  const reel = h / w > 1.7;
  const pct = (v: number, of: number) => `${(v / of) * 100}%`;
  const box = (x: number, y: number, bw: number, bh: number) => ({ left: pct(x, w), top: pct(y, h), width: pct(bw, w), height: pct(bh, h) });
  const label = 'absolute rounded px-1.5 py-0.5 text-[10px] font-medium leading-tight text-white whitespace-nowrap';
  return (
    <div className="absolute left-0 top-0 w-full pointer-events-none" style={{ aspectRatio: `${w} / ${h}` }} data-testid="grid-guides" aria-hidden>
      {/* hidden on the grid: dimmed */}
      {tall ? (<>
        <div className="absolute bg-black/35" style={box(0, 0, w, crop.y)} />
        <div className="absolute bg-black/35" style={box(0, crop.y + crop.h, w, h - crop.y - crop.h)} />
      </>) : crop.x > 0 && (<>
        <div className="absolute bg-black/35" style={box(0, 0, crop.x, h)} />
        <div className="absolute bg-black/35" style={box(crop.x + crop.w, 0, w - crop.x - crop.w, h)} />
      </>)}
      <div className="absolute border-2 border-dashed border-amber-400" style={box(crop.x, crop.y, crop.w, crop.h)}>
        <span className={`${label} bg-amber-500/90 left-1 top-1`}>Profile grid shows this (3:4)</span>
      </div>
      {reel && (<>
        <div className="absolute border border-dashed border-rose-400/90 bg-rose-500/10" style={box(0, 0, w, 220)}>
          <span className={`${label} bg-rose-500/85 right-1 bottom-1`}>Reel top bar</span>
        </div>
        <div className="absolute border border-dashed border-rose-400/90 bg-rose-500/10" style={box(w - 150, h - 1000, 150, 600)}>
          <span className={`${label} bg-rose-500/85 right-1 top-1`}>Buttons</span>
        </div>
        <div className="absolute border border-dashed border-rose-400/90 bg-rose-500/10" style={box(0, h - 400, w, 400)}>
          <span className={`${label} bg-rose-500/85 left-1 top-1`}>Reel caption</span>
        </div>
      </>)}
    </div>
  );
}
